<template>
    <div class="py-3 row">
        <div class="col-md-4 col-12">
            <div class="border bg-white p-2">
                <h6>
                    <i class="fas fa-user-circle text-app-primary"></i>
                    {{ eligibility.subscriber.first_name
                    }}{{ eligibility.subscriber.middle_name ? ", " + eligibility.middle_name : ""
                    }}{{ eligibility.subscriber.last_name ? ", " + eligibility.subscriber.last_name : "" }}
                </h6>
                <p class="my-1">
                    <span v-if="eligibility.subscriber.gender">{{ eligibility.subscriber.gender }}</span>
                    <span v-if="eligibility.subscriber.identification_code">
                        <span v-if="eligibility.subscriber.gender">, </span>Medicare Number:
                        {{ eligibility.subscriber.identification_code }}</span
                    >
                </p>
                <p class="my-1" v-if="eligibility.subscriber.date">
                    Date of Birth: {{ formatDate(eligibility.subscriber.date) }}
                </p>
            </div>
        </div>
        <div class="col-md-4 col-12" v-if="eligibility.medicare_Part_A.success == 'Yes'">
            <div class="border bg-white p-2">
                <h6>
                    <i class="fas fa-check-circle text-success"></i>
                    {{ eligibility.medicare_Part_A.insurance_type_code }}
                </h6>
                <p class="my-1" v-if="eligibility.medicare_Part_A.eligibility_or_benefit_information">
                    {{ eligibility.medicare_Part_A.eligibility_or_benefit_information }}
                </p>
                <p class="my-1" v-if="eligibility.medicare_Part_A.date">
                    <i class="fas fa-calendar-alt"></i>
                    {{ formatDate(eligibility.medicare_Part_A.date) }}
                </p>
            </div>
        </div>
        <div class="col-md-4 col-12" v-if="eligibility.medicare_Part_B.success == 'Yes'">
            <div class="border bg-white p-2">
                <h6>
                    <i class="fas fa-check-circle text-success"></i>
                    {{ eligibility.medicare_Part_B.insurance_type_code }}
                </h6>
                <p class="my-1" v-if="eligibility.medicare_Part_B.eligibility_or_benefit_information">
                    {{ eligibility.medicare_Part_B.eligibility_or_benefit_information }}
                </p>
                <p class="my-1" v-if="eligibility.medicare_Part_B.date">
                    <i class="fas fa-calendar-alt"></i>
                    {{ formatDate(eligibility.medicare_Part_B.date) }}
                </p>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { formatDate } from "../../../../common/vue-helpers/modifiers/value-modifier";

export default defineComponent({
    props: {
        eligibility: {
            type: Object
        }
    },
    data() {
        return {
            formatDate
        };
    }
});
</script>
